@if(isLoading) {
<kzn-loader [message]="'loaderEmailTemplates' | translate"></kzn-loader>
} @else if(isError) {
<kzn-status-message [message]="errorMessage"></kzn-status-message>
} @else {
<div class="email-tpl-page">
  <div class="email-tpl-page__header">
    <div class="email-tpl-page__header-icon">
       <img src="assets/email_icon.png" alt="" class="email-tpl-page__header-icon" />
    </div>
    <span class="email-tpl-page__header-title">{{ 'emailTemplatesPageTitle' | translate }}</span>
  </div>

  <div class="email-tpl-page__card">
    <kzn-table [data]="allEmailTemplates" [columns]="tableColumns" style="width: 100%" [showRefresh]="true"
      (refreshEventFired)="getAllEmailTemplates()" [rowActions]="tableRowActions"
      [defaultSortColumnDef]="defaultSortColumnDef" [defaultSortDirection]="defaultSortDirection">
      <ng-container header-right>
        <button type="button" class="email-tpl-page__create-btn" (click)="onCreateEmailTemplate()"
          [disabled]="allEmailTemplates.length >= Constants.MAX_EMAIL_TEMPLATE_COUNT">
          <mat-icon>add</mat-icon>{{ 'createEmailTemplate' | translate }}
        </button>
      </ng-container>
    </kzn-table>
  </div>
</div>
}
